import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setPopup } from '../../../../redux/messageSlice';
import MessageSkeleton from '../../../Skeleton/MessageSkeleton';
import Message from '../../../connect/chat/Message';
import { GET_SEPERATOR, IsGroupMsg } from '../../../../Utils/Common';
import MessageNotFound from '../../../connect/chat/MessageNotFound';
import CustomEditor from '../../../connect/chat/CustomEditor';
import MessageDrawer from '../../../connect/chat/MessageDrawer';

function DiscussionSection() {

  const dispatch = useDispatch();
  const { task_id } = useParams();
  const { msg_drawer } = useSelector((state) => state.message);
  const { active_discussion, active_task } = useSelector(state => state.task)
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
      dispatch(setPopup({ key: 'chat_loader', value: false }))
    }, 1000); // simulate API delay

    return () => clearTimeout(timeout);
  }, []);
  
  return (
    <div className="bg-white pt-6 flex flex-col h-[calc(100vh-281px)] dark:bg-surface-dark">
      <>
        <div className='w-full flex flex-col gap-4 h-full'>
          <div className="messageDiv h-[calc(100%-75px)] overflow-y-auto">
            {
              loading ? (
                <MessageSkeleton counter={20} />
              ) : (
                active_discussion.length > 0 ? (
                  active_discussion.map((v, i) => (
                    <Message
                      key={v.msg_id}
                      data={v}
                      seperator={GET_SEPERATOR(active_discussion[i - 1], v)}
                      is_group_msg={IsGroupMsg(active_discussion[i - 1], v)}
                    />
                  ))
                ) : (
                  <MessageNotFound conversation_id={active_task?.conversation_id} type="task" />
                )
              )
            }
          </div>
          <CustomEditor task={active_task} type="task" position='!relative' />
        </div>

        {msg_drawer && task_id && <MessageDrawer />}
      </>
    </div>
  )
}

export default DiscussionSection